import PermissionLowHierarchySelection from '../../../../dataViews/NextTree/plugins/PermissionLowHierarchySelection';
export default {
    makeTreePlugin: () => new PermissionLowHierarchySelection(),
};
